import { Dialog } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CustomButton from "common/components/Button/Button"
import Modal from "common/components/Modal/Modal"
import { nanoid } from "nanoid"
import { Tooltip } from "primereact/tooltip"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import CamposPersonalizadosForm from "../NewPrestamoForm/components/CamposPersonalizadosForm"
import ComisionesModalForm from "../NewPrestamoForm/components/ComisionesForm"
import PrestamosLabelBox from "../PrestamosLabelBox"
import "./styles.scss"

const NewComisionBoard = ({
  title,
  data,
  handleBlur,
  setFieldValue,
  className = "",
  fieldKey,
  modalTitle,
  tabSelected,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [elements, setElements] = useState(data)
  const [openEditModal, setOpenEditModal] = useState({
    camposPersonalizados: {
      status: false,
      value: null,
    },
    comisiones: {
      status: false,
      value: null,
    },
  })

  useEffect(() => {
    setElements(data)
  }, [data])

  const handleOpenModal = (
    value: $TSMigrationFixMe,
    status: $TSMigrationFixMe
  ) => {
    // @ts-expect-error TS(2345): Argument of type '{ [x: number]: { status: $TSFixMe; va...
    setOpenEditModal({ [fieldKey]: { status, value } })
  }

  const handleAddElement = (values: $TSMigrationFixMe) => {
    const elementsCopy = elements.slice()
    const elementsAdded = [
      ...elementsCopy,
      {
        label: values.label,
        value: values.value,
        extraValue: values.extraValue,
        key: nanoid(),
        elementId: nanoid(),
        originalObject: values.originalObject,
      },
    ]

    handleOpenModal(null, false)
    setElements(elementsAdded)
    setFieldValue(fieldKey, elementsAdded)
  }

  const handleRemoveElement = (id: $TSMigrationFixMe) => {
    const elementsCopy = elements.filter(
      (element: $TSMigrationFixMe) => element.elementId !== id
    )
    setElements(elementsCopy)
    setFieldValue(fieldKey, elementsCopy)
  }

  const handleEditElement = (value: $TSMigrationFixMe) => {
    const elementsCopy = elements.map((element: $TSMigrationFixMe) => {
      if (element.elementId === value.elementId) {
        return {
          ...element,
          label: value.label,
          value: value.value,
          extraValue: value.extraValue,
          key: value.elementId,
          elementId: value.elementId,
          originalObject: value.originalObject,
        }
      }
      return element
    })

    handleOpenModal(null, false)
    setElements(elementsCopy)
    setFieldValue(fieldKey, elementsCopy)
  }

  return (
    <div className={`comision-main_container ${className}`}>
      <header className='comision-header'>
        {fieldKey === "camposPersonalizados" ? (
          <div className='flex gap-3 align-items-center'>
            <h6>{title}</h6>
            <Tooltip
              target='.tooltip-info'
              content='Usa los campos personalizados para guardar datos extra relevantes'
              position='bottom'
              className='tooltip-cartera-header'
            />
            <span className='tooltip-info'>
              <FontAwesomeIcon icon={["fal", "circle-info"]} />
            </span>
          </div>
        ) : (
          <h6>{title}</h6>
        )}

        <FontAwesomeIcon
          icon={["fal", "plus"]}
          onClick={() => handleOpenModal(null, true)}
        />
      </header>
      <section className='comision-board'>
        {elements?.length ? (
          elements?.map(
            ({
              label,
              value,
              extraValue,
              key,
              elementId,
              originalObject,
            }: $TSMigrationFixMe) => (
              <div
                key={key}
                className='mb-2 comision-board-box'
              >
                <PrestamosLabelBox
                  label={label}
                  value={value}
                  extraValue={extraValue}
                />
                <div className='comision-icon_container'>
                  <FontAwesomeIcon
                    icon={["fal", "trash-can"]}
                    className='icon-item icon-item-danger'
                    onClick={() => handleRemoveElement(elementId)}
                  />
                  <FontAwesomeIcon
                    icon={["fal", "pen"]}
                    className='icon-plus'
                    onClick={() =>
                      handleOpenModal(
                        {
                          label,
                          value,
                          extraValue,
                          key,
                          elementId,
                          originalObject,
                        },
                        true
                      )
                    }
                  />
                </div>
              </div>
            )
          )
        ) : (
          <div className='d-flex justify-content-center empty-comision-board'>
            <div>
              <CustomButton
                className='mr-2 btn-primary button-outline'
                label={`${t("impuestos.modalNew.addButton")}${modalTitle}`}
                onClick={() => handleOpenModal(null, true)}
              />
            </div>
          </div>
        )}

        <Dialog
          header={
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
            openEditModal[fieldKey]?.value
              ? `${t("impuestos.modalNew.modalNew")}`
              : `${t("impuestos.modalNew.newTitle")}`
          }
          visible={openEditModal.comisiones?.status}
          onHide={() => handleOpenModal(null, false)}
          keepInViewport={false}
          draggable
          className='tw-w-112'
        >
          <ComisionesModalForm
            handleBlur={handleBlur}
            values={openEditModal.comisiones?.value}
            tabSelected={tabSelected}
            handleElement={
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
              openEditModal[fieldKey]?.value
                ? handleEditElement
                : handleAddElement
            }
            handleOpenModal={handleOpenModal}
          />
        </Dialog>
        <Modal
          header={
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
            openEditModal[fieldKey]?.value
              ? `${t("impuestos.modalNew.fielEdit")}`
              : `${t("impuestos.modalNew.newPersonalicedField")}`
          }
          visible={openEditModal.camposPersonalizados?.status}
          onHide={() => handleOpenModal(null, false)}
          size='small'
          maskClassName='!tw-z-50'
          className='departaments-modal'
        >
          <CamposPersonalizadosForm
            handleBlur={handleBlur}
            values={openEditModal.camposPersonalizados?.value}
            handleElement={
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
              openEditModal[fieldKey]?.value
                ? handleEditElement
                : handleAddElement
            }
            handleOpenModal={handleOpenModal}
          />
        </Modal>
      </section>
    </div>
  )
}

export default NewComisionBoard
